module.exports = __webpack_public_path__ + "img/service2-04.20e985a2.png";